// extracted by mini-css-extract-plugin
export var btn = "CourseGoal-module--btn--JxyVJ";
export var description = "CourseGoal-module--description--K0a8N";
export var title = "CourseGoal-module--title--txNAs";
export var wrapper = "CourseGoal-module--wrapper--2F+2n";